import { isValid, parseISO } from 'date-fns'

import type { IAppVersionInfo } from './interfaces'

export function formatVersionInfo(versionInfo: IAppVersionInfo) {
  return versionInfo.buildNumber && versionInfo.buildNumber !== ''
    ? `${versionInfo.version}.${versionInfo.buildNumber}`
    : versionInfo.version
}

/**
 * Checks the validity of version info.
 *
 * Required since we sometimes get empty values for the client version
 * information in the absence of a unified version.
 *
 * FIXME: This is a temporary measure and should be removed when consistent
 *        version information is provided.
 *
 * @param versionInfo The version information object to assess
 *
 * @returns `true` when the version information is valid, `false` otherwise.
 */
export function isVersionInfoValid(
  versionInfo?: Partial<IAppVersionInfo>,
): versionInfo is IAppVersionInfo {
  if (versionInfo === undefined) {
    return false
  }

  let versionValid = false
  let buildDateTimeValid = false

  if (
    versionInfo.buildDateTime &&
    isValid(parseISO(versionInfo.buildDateTime))
  ) {
    buildDateTimeValid = true
  }

  if (versionInfo.version && versionInfo.version !== '') {
    versionValid = true
  }

  return versionValid && buildDateTimeValid
}
